
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"; // Import external CSS
import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import { FiUpload } from "react-icons/fi";
import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDropdownDocumentType from "../../../Components/CustomDropDown/CustomDropdownDocumentType";
import FileUploadForCreateUser from "../../../Components/FileUploadComponent/FileUploadForCreateUser";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions/index";
// import { toast, ToastContainer } from "react-toastify";
import { toast, ToastContainer } from "react-toastify";

import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import CustomAddCountryInput from "../../../Components/CustomInputLogin/CustomAddCountryInput";
import TabComponent from "../../Operator/OperatorDashboard/TabComponent";
import { IoMdTime } from "react-icons/io";
import { FaRegCheckCircle } from "react-icons/fa";
import CountryAdd from "../AddCountry/TabComponentsForCountry/CountryAdd";
import StateAdd from "../AddCountry/TabComponentsForCountry/StateAdd";
import CityAdd from "../AddCountry/TabComponentsForCountry/CityAdd";
import KycAdd from "../AddCountry/TabComponentsForCountry/KycAdd";
import AddCountryTabComponent from "../../Operator/OperatorDashboard/AddCountryTabComponent";

const AddCountryModal = ({
    open,
    onClose,
    setSubmittedValues,
    submittedValues,
    modalHeadingName,
}) => {
    // const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedDocumentType, setSelectedDocumentType] = React.useState("");

    const [tabValue, setTabValue] = React.useState(0);


    const dispatch = useDispatch();


    const [formValues, setFormValues] = useState({
        name: "",
        roleName: "",
        emiratesid: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
    });


    console.log(formValues, "formValuessssss")
    const { multiUserCreation } = useSelector(
        (state) => state?.multiUserCreation
    );

    const { updateAuthUser } = useSelector(
        (state) => state?.updateAuthUser
    );


    const token = sessionStorage.getItem('token');

    const UserCreateSubmit = async (values, { resetForm }) => {
        console.log(values, "vaUserCreateSubmitUserCreateSubmitlues");

        console.log(token, "tokennnn")

        if (!customerId) {
            const data1 = {
                data: values,
                method: "post",
                apiName: `registerAuthUser`,
                // headers: {
                //   Authorization: `Bearer ${token}`,  // Pass auth token in headers
                //   "Content-Type": "application/json",
                // },
            };
            const multiUserCreationResponse = await dispatch(
                actions.MULTIUSERCREATION(data1)
            );

            if (
                multiUserCreationResponse.payload.message ===
                "User registered successfully."
            ) {
                toast.success(`${multiUserCreationResponse.payload.message}`)
                resetForm();

                setTimeout(() => onClose(), 1500);
            } else {
                // toast.error(`${multiUserCreationResponse.payload.message}`);
                toast.error(`${multiUserCreationResponse.payload.message}`)
            }
        }

        if (customerId) {

            console.log(customerId, "ediiiiiiiiiiit");

            const data1 = {
                data: values,
                method: "put",
                apiName: `updateAuthUser/${customerId}`,
                headers: {
                    Authorization: `Bearer ${token}`,  // Pass auth token in headers
                    "Content-Type": "application/json",
                },
            };
            const updateAuthUserResponse = await dispatch(
                actions.UPDATEAUTHUSER(data1)
            );

            if (
                updateAuthUserResponse.payload.message ===
                "User updated successfully."
            ) {

                toast.success(`${updateAuthUserResponse.payload.message}`);


                resetForm();

                setTimeout(() => onClose(), 2500);
                dispatch(clearCustomerId(null))
                dispatch(clearTableGetId(null))
            } else {
                toast.error(`${updateAuthUserResponse.payload.message}`);
            }

        }
    };

    const { createRoleWithPermissions } = useSelector(
        (state) => state?.createRoleWithPermissions
    );

    const { getAllRoles } = useSelector(
        (state) => state?.getAllRoles
    );


    useEffect(() => {
        // if (!open) return;

        const fetchData = async () => {
            const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
            await dispatch(actions.GETALLROLES(data1));
        };
        fetchData();
    }, [dispatch, createRoleWithPermissions]);



    const [getAllRolesData, setGetAllRolesData] = useState([]);


    useEffect(() => {
        const tempArr = [];
        getAllRoles?.data?.map((data, index) => {
            return tempArr.push({
                label: data?.roleName,
                value: data?.roleName
            });
        });
        setGetAllRolesData(tempArr);
    }, [dispatch, getAllRoles, createRoleWithPermissions]);



    // edit-----------------------------------------------

    const { getAuthUserById } = useSelector((state) => state?.getAuthUserById);
    const customerId = useSelector((state) => state.customer.customerId);

    console.log(customerId, "hindkdmkfmdkdmdkfmslfmkldmfa");


    console.log(getAuthUserById?.data, "getAuthUserByIdgetAuthUserById");

    useEffect(() => {
        if (!open) return;
        const fetchData = async () => {
            if (customerId) {
                const data1 = { data: {}, method: "get", apiName: `getAuthUserById/${customerId}` };
                const getAuthUserByIdResponese = await dispatch(actions.GETAUTHUSERBYID(data1));

                console.log(getAuthUserByIdResponese?.payload?.data, "getAuthUserByIdResponese");


                setFormValues({
                    name: getAuthUserByIdResponese?.payload?.data?.name,
                    roleName: getAuthUserByIdResponese?.payload?.data?.userRole,
                    emiratesid: "",
                    email: getAuthUserByIdResponese?.payload?.data?.email,
                    phone: getAuthUserByIdResponese?.payload?.data?.phone,
                    password: getAuthUserByIdResponese?.payload?.data?.password,
                    confirm_password: getAuthUserByIdResponese?.payload?.data?.password,
                })

            } else {
                setFormValues({
                    name: "",
                    roleName: "",
                    emiratesid: "",
                    email: "",
                    phone: "",
                    password: "",
                    confirm_password: "",
                })

            }
        };
        fetchData();
    }, [dispatch, customerId]);



    const [inputValue, setInputValue] = useState("");

    console.log(inputValue, "inputValueinputValueinputValue")



    const tabsHeadData = [
        { label: 'Country', icon: "" },
        { label: 'State', icon: "" },
        { label: 'City', icon: "" },
        { label: 'Kyc', icon: "" },


    ];

    const tabsComponent = [
        <CountryAdd setTabValue={setTabValue} />,
        <StateAdd setTabValue={setTabValue} />,
        <CityAdd setTabValue={setTabValue} />,
        <KycAdd setTabValue={setTabValue} onClose={onClose} />

        // <TotalApprovedRegistration />,
    ];
    return (
        <Dialog
            open={open}
            // onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                maxWidth: "600px",
                margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >


            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearCustomerId(null))
                            dispatch(clearTableGetId(null))


                        }}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "text.secondary",
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography className="custom-title-text" color="white">
                                {/* {customerId ? "Update User Details" : modalHeadingName} */}
                                Add Country
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>


                <DialogContent sx={{
                    background: "#F7F7F7",

                }}>
                    <AddCountryTabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} value={tabValue} setValue={setTabValue} />

                </DialogContent>
                {/* <Formik

                    enableReinitialize
                    initialValues={{ country: [] }}
                    validationSchema={Yup.object({
                        country: Yup.array().min(1, "At least one country is required"),
                    })}
                    onSubmit={(values, { setFieldValue }) => {
                        if (inputValue.trim() !== "") {
                            values.country = [...values.country]; // Include the last typed value
                        }
                        console.log(values, "valuessssss")
                    }}
                >
                    {({ handleSubmit, setFieldValue, resetForm, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent dividers>
                                <Grid container spacing={2} mb={4}>
                                    <Grid item xs={12} md={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <CustomAddCountryInput
                                                    label="Country"
                                                    name="country"
                                                    inputType="text"
                                                    custPlaceholder="Enter Country"
                                                    setFieldValue={setFieldValue}
                                                    values={values.country}
                                                    inputValue={inputValue} // Pass inputValue
                                                    setInputValue={setInputValue} //

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Divider />

                               
                                <Grid sx={{ display: "flex", justifyContent: "end", mt: 1 }}>
                                    <Grid>
                                        <Button
                                            onClick={() => {
                                                resetForm();
                                                setUploadedFiles(null);
                                                onClose()
                                                dispatch(clearCustomerId(null))
                                                dispatch(clearTableGetId(null))


                                            }}
                                            variant="text"
                                            // className="custom-clear-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                mr: "10px",
                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "white",
                                                boxShadow: "none",
                                                color: "black",
                                                border: "1px solid black",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // className="custom-ok-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                boxShadow: "none",

                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "#C38F51 0% 0% no-repeat padding-box",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    boxShadow: "none",
                                                },
                                            }}
                                        >
                                            {customerId ? "Update" : "Submit"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogContent>

                        </Form>
                    )}
                </Formik> */}
                <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                />
            </Box>
        </Dialog>
    );
};

export default AddCountryModal;




// import React from 'react';
// import { useDispatch } from 'react-redux';
// import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
// import { IoMdTime } from 'react-icons/io';
// import { FaRegCheckCircle } from 'react-icons/fa';
// import TabComponent from '../TabComponent';
// import TotalPendingRegisration from './TotalPendingRegisration';
// import TotalApprovedRegistration from './TotalApprovedRegistration';

// const TotalRegistrationTabComponent = () => {
//     const dispatch = useDispatch();

//     React.useEffect(() => {
//         dispatch(setHeaderName("Total Registration"));
//     }, [dispatch]);

//     const tabsHeadData = [
//         { label: 'Pending', icon: <IoMdTime /> },
//         { label: 'Approved', icon: <FaRegCheckCircle /> },
//     ];

//     const tabsComponent = [
//         <TotalPendingRegisration />,
//         <TotalApprovedRegistration />,
//     ];

//     return (
//         <div>
//             <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
//         </div>
//     );
// };

// export default TotalRegistrationTabComponent;
